import 'jwt-decode';
import jwt from 'jsonwebtoken';
export const tokenService = {
    sign: ({ auth }) => {
        const token = {
            nameid: '',
            exp: Math.floor(Date.now() / 1000) + 60 * 60 * 120,
            iss: auth.jwt.issuer || 'refract-cms',
            aud: 'refract-cms',
        };
        return jwt.sign(token, auth.jwt.secret);
    },
    verify: (token, { auth }) => {
        try {
            return jwt.verify(token, auth.jwt.secret);
        }
        catch (error) {
            return null;
        }
    },
};
